import React from 'react';
import {NUM_FILTER_PILLS_DISPLAYED} from '../../utils/constants';
import FilterPill from '../FilterPill/FilterPill';

type Props = {
    placeholdersCount: number;
};

export default function FilterBarLoading({
    placeholdersCount = NUM_FILTER_PILLS_DISPLAYED,
}: Props) {
    return (
        <>
            {Array(placeholdersCount)
                .fill('')
                .map((_, index) => (
                    <FilterPill label={''} key={index} loading />
                ))}
        </>
    );
}
